<template>
    <el-drawer v-model="cashview" size="70%" direction="rtl" :before-close="handleClose">
        <div class="TTL-table top20">
            <el-table :data="cashdata" stripe="true" empty-text="">
                <template v-slot:empty><el-empty description="暂无红包数据" /></template>
                <el-table-column label="会员头像" align="center">
                    <template #default="scope">
                        <wcimage :option="{size:'middle'}" :value="scope.row.memberavatar" />
                    </template>
                </el-table-column>
                <el-table-column label="会员名称" align="center">
                    <template #default="scope">
                        <span>{{scope.row.membername}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="系统标签" align="center">
                    <template #default="scope">
                        <span>{{scope.row.robot_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="塞红包/领取红包" align="center">
                    <template #default="scope">
                        <span style="color:red;font-weight:bold;">{{scope.row.pid==0 ? scope.row.cash : '-'+scope.row.cash}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" align="center">
                    <template #default="scope">
                        <span>{{scope.row.inputtime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联微信支付单号" align="center">
                    <template #default="scope">
                        <span>{{scope.row.transation_id ? scope.row.transation_id : '/'}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props:['view','data'],
    data() {
        return {
            cashview:false,
            cashdata:[]
        }
    },
    watch: {
        view(val){
            if(val) {
                this.cashview=true;
                this.cashdata=this.data;    
            }
        },
    },
    mounted() {
        
    },
    methods: {

        /** 关闭窗口 **/
        handleClose() {
            this.cashview=false;
            this.$emit('finish');
        },

    },
}
</script>
<style scoped>

</style>